<template>
  <div class="">
    <main style="width: 100%">
      <div v-if="isLoading" class="loading-state">
        <div class="spinner-container">
          <div class="mt-5 spinner"></div>
        </div>
      </div>

      <div v-else>
        <ErrorState
          v-if="error"
          title="Failed to Load Makercart Activities"
          :message="error"
          :error-code="errorCode"
        />
        <div v-else class="item-list-maker-cart">
          <div v-if="items.length === 0" class="no-items-message">
            <ErrorState
              state="notFound"
              :title="emptyStateTitle"
              :message="notFoundMessage"
            />
          </div>
          <div v-else class="item-grid-container">
            <ItemMakerCart
              v-for="item in items"
              :key="item.makercart_id"
              :item="item"
              :isLogged="isUserLogged"
              @update-liked-status="updateLikedStatus"
              @item-clicked="handleItemClicked(item.makercart_id)"
            />
          </div>
        </div>
      </div>
    </main>

    <BasePagination
      v-if="totalPages > 1 && !error"
      :model-value="currentPage"
      :total-pages="totalPages"
      class="mb-5"
      @update:model-value="changePage"
    />
  </div>
</template>

<script setup>
import ErrorState from "@/components/common/ErrorState.vue";
import ItemMakerCart from "@/components/maker-cart/ItemMakerCart.vue";
import BasePagination from "@/components/common/BasePagination.vue";
import { defineProps, defineEmits } from "vue";

defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  error: {
    type: String,
    default: null,
  },
  errorCode: {
    type: String,
    default: null,
  },
  isUserLogged: {
    type: Boolean,
    default: false,
  },
  emptyStateTitle: {
    type: String,
    default: "No makercart activities available",
  },
  notFoundMessage: {
    type: String,
    default:
      "No makercart activities are currently available. Please check back later.",
  },
  currentPage: {
    type: Number,
    default: 1,
  },
  totalPages: {
    type: Number,
    default: 0,
  },
  visiblePages: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits([
  "update-liked-status",
  "item-clicked",
  "page-changed",
]);

const updateLikedStatus = (data) => {
  emit("update-liked-status", data);
};

const handleItemClicked = (makercartId) => {
  emit("item-clicked", makercartId);
};

const changePage = (page) => {
  emit("page-changed", page);
};
</script>

<style scoped>
.item-list-maker-cart {
  flex-wrap: wrap;
  padding: 20px 0px;
  min-height: 70vh;
  justify-content: center;
}

.item-grid-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.item-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
}

.item-grid > * {
  flex: 1 1 calc(50% - 20px);
  max-width: calc(50% - 20px);
  box-sizing: border-box;
  height: auto;
}

@media (max-width: 768px) {
  .item-grid > * {
    flex: 1 1 100%;
    max-width: 100%;
  }
}

@media (max-width: 1200px) {
  .item-grid-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .item-grid-container {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 30px;
    padding: 0 8px;
    margin-bottom: 24px;
  }

  .item-list-maker-cart {
    padding: 0px;
    min-height: 50vh;
  }
}

.no-items-message {
  text-align: center;
  width: 100%;
  padding: 20px;
}

.no-search-message {
  text-align: center;
  width: 100%;
  padding: 20px;
}

.loading-state {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.error-message {
  text-align: center;
  width: 100%;
  padding: 20px;
  color: red;
}
</style>
